module.exports = __webpack_public_path__ + "img/E-WEB-Goal-07.d9ea2d75.svg";